mutation CompanyCorporatePeriodRangeCreate(
  $input: CompanyCorporatePeriodRangeCreateInput!
) {
  companyCorporatePeriodRangeCreate(input: $input) {
    createdPeriods
  }
}
